module.exports = __webpack_public_path__ + "static/media/manual-screen-6.51e9b7e4.png";